//#region Imports
import { useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';

import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';
//#endregion

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

export const CreateBrandModal = ({ showModal, setShowModal, refreshData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');

  const handleClose = () => {
    setShowModal(false);
    setName('');
    refreshData();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await customAxios.post(
        `${GlobalVariables.getURL()}brands/`,
        { name },
        HEADERS,
      );
      if (response.status >= 200 && response.status < 300) {
        getToast({
          status: 'success',
          title: 'Marca creada exitosamente en la base de datos.',
        });
        handleClose();
      }
    } catch (error) {
      console.log('Error creating brand:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Nueva marca
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{ position: 'absolute', right: 20, top: 20, width: 40, height: 40 }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='create-brand-form' onSubmit={handleSubmit}>
          <TextField
            required
            fullWidth
            disabled={isLoading}
            label='Nombre'
            placeholder='Nombre...'
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='create-brand-form'
          type='submit'
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
